import React from 'react';
import RecentlyViewed from './RecentlyViewed';
import GoogleRelated from './GoogleRelated';
import { useSmartModuleContext } from '../SmartModuleProvider';
import { useTrackingContext } from '@jbhi-fi/components/src/Tracking';
import { SmartModuleSettings } from '../../../../../global';

export type SmartModuleType = 'frequentlyBoughtTogether' | 'recommendedForYou' | 'recentlyViewed';

type SmartModuleWrapperProps = {
  settings: SmartModuleSettings;
  location: 'pdpTop' | 'pdpBottom' | 'pdpMiddle' | 'productAttach' | 'homePage' | 'search' | 'cart';
  isMarketplaceProduct?: boolean;
  variant?: 'carousel' | 'list';
};

export const SmartModuleWrapper = ({
  settings,
  isMarketplaceProduct,
  location,
  variant = 'carousel',
}: SmartModuleWrapperProps) => {
  const { smartModulesData, isEnhancedGoogleRecommendationsEnabled } = useSmartModuleContext();
  const { tracker } = useTrackingContext();
  const { type, title } = settings;

  if (!smartModulesData[`${type}AlgoliaData`]) return null;

  if (type === 'recentlyViewed')
    return (
      <RecentlyViewed
        location={location}
        data={smartModulesData[`${type}AlgoliaData`]}
        settings={settings}
        page={tracker.context ?? ''}
        isEnhancedGoogleRecommendationsEnabled={isEnhancedGoogleRecommendationsEnabled}
        variant={variant}
      />
    );

  if (settings?.googleRecModelType && isMarketplaceProduct) return null;

  return (
    <GoogleRelated
      data={smartModulesData[`${type}AlgoliaData`]}
      title={title}
      type={type}
      page={tracker.context ?? ''}
      location={location}
      settings={settings}
      variant={variant}
      isEnhancedGoogleRecommendationsEnabled={isEnhancedGoogleRecommendationsEnabled}
    />
  );
};
